module.exports = __webpack_public_path__ + "img/fb32949590a38365ab0ee545e960ca71.a7e13e37.png";